/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DataChartBarsXUpIcon16Light } from './DataChartBarsXUpIcon16Light';
import { DataChartBarsXUpIcon16Regular } from './DataChartBarsXUpIcon16Regular';
import { DataChartBarsXUpIcon16Solid } from './DataChartBarsXUpIcon16Solid';
import { DataChartBarsXUpIcon20Light } from './DataChartBarsXUpIcon20Light';
import { DataChartBarsXUpIcon20Regular } from './DataChartBarsXUpIcon20Regular';
import { DataChartBarsXUpIcon20Solid } from './DataChartBarsXUpIcon20Solid';
import { DataChartBarsXUpIcon24Regular } from './DataChartBarsXUpIcon24Regular';
import { DataChartBarsXUpIcon24Solid } from './DataChartBarsXUpIcon24Solid';
import { DataChartBarsXUpIcon32Regular } from './DataChartBarsXUpIcon32Regular';
import { DataChartBarsXUpIcon64Regular } from './DataChartBarsXUpIcon64Regular';
var sizes = {
    16: {
        light: DataChartBarsXUpIcon16Light,
        regular: DataChartBarsXUpIcon16Regular,
        solid: DataChartBarsXUpIcon16Solid,
    },
    20: {
        light: DataChartBarsXUpIcon20Light,
        regular: DataChartBarsXUpIcon20Regular,
        solid: DataChartBarsXUpIcon20Solid,
    },
    24: {
        regular: DataChartBarsXUpIcon24Regular,
        solid: DataChartBarsXUpIcon24Solid,
    },
    32: {
        regular: DataChartBarsXUpIcon32Regular,
    },
    64: {
        regular: DataChartBarsXUpIcon64Regular,
    },
};
export var DataChartBarsXUpIcon = forwardRef('DataChartBarsXUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
